module.exports = __webpack_public_path__ + "img/Frame 2123.e1ff50bd.png";